import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Entitytag } from '@src/app/models/entitytag';
import { Filtertag } from '@src/app/models/filtertag';
import { Tag } from '@src/app/models/tag';
import { TagaddremoveService } from '../tagaddremove/service/tagaddremove.service';
import { TagfilterService } from './service/tagfilter.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-tagfilter',
  templateUrl: './tagfilter.component.html',
  styleUrls: ['./tagfilter.component.css']
})
export class TagfilterComponent implements OnInit, OnChanges {
  @Input() tagtype: string;
  @Input() listToFilter: any[];
  @Output() filteredList = new EventEmitter<any[]>();
  filtertext: string;
  showTags: boolean;
  taglist: Tag[];
  filtertagList: Filtertag[];
  @Input() label: boolean = false;
  constructor(private tfsrv: TagfilterService, private uieventhub: UieventhubService, private datastore: DatastoreService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listToFilter && changes.listToFilter.currentValue && changes.listToFilter.currentValue.length > 0) {
      this.datastore.filtertagList$.pipe(untilDestroyed(this)).subscribe(elist => {
        //this.tfsrv.getFilterTags(this.tagtype).pipe(untilDestroyed(this)).subscribe(elist => {
        //console.log('elist changes',elist);
        if (elist.length > 0) {
          this.filtertagList = elist.filter(x => x.tagtype == this.tagtype);
          this.filterList();

        } else {
          this.filtertagList = [];
          this.filteredList.emit(this.listToFilter);
        }

      });
    } else if (changes.listToFilter && changes.listToFilter.currentValue && changes.listToFilter.currentValue.length == 0) {
      this.filteredList.emit(this.listToFilter);
    }
  }
  ngOnInit(): void {
    this.datastore.filtertagList$.pipe(untilDestroyed(this)).subscribe(elist => {
      //this.tfsrv.getFilterTags(this.tagtype).pipe(untilDestroyed(this)).subscribe(elist => {
      //console.log('elist init',elist);
      if (elist.length > 0) {
        this.filtertagList = elist.filter(x => x.tagtype == this.tagtype);
        this.filterList();

      } else {
        this.filtertagList = [];
        this.filteredList.emit(this.listToFilter);
      }
      if (this.tagtype === 'project') {
        this.uieventhub.setTagFilterApplied(this.filtertagList);
      }

    });
    this.datastore.tags$.pipe(untilDestroyed(this)).subscribe(t => {
      // this.tfsrv.getTags(this.tagtype).pipe(untilDestroyed(this)).subscribe(t => {
      this.taglist = t.filter(x => x.tagtype == this.tagtype);
    });
    //TODO If any filter tags set => Get entity tags of type and filter listToFilter. -DONE
    //Implement as function and call function when tags are added and removed from filter. -DONE
    //What to do when tags are added or removed from entities? 
    //What to do when elements are added to list?
  }

  filterList() {
    if (this.listToFilter && this.listToFilter.length > 0) {
      if (this.filtertagList.length > 0) {
        if (this.tagtype == 'project') {
          this.uieventhub.setTagFilterApplied(this.filtertagList);
        }

        // Create array of observables for all entity tag requests
        const tagRequests = this.listToFilter.map(element =>
          this.tfsrv.getEntityTags(element[this.tagtype + 'Id'], this.tagtype).pipe(
            map(etags => ({
              element,
              etags,
              matches: etags.some(etag => this.filtertagList.some(filtertag => filtertag.tagId == etag.tagId))
            })),
            untilDestroyed(this)
          )
        );

        // Wait for all requests to complete
        forkJoin(tagRequests).pipe(untilDestroyed(this)).subscribe(results => {
          const list = results
            .filter(result => result.matches)
            .map(result => result.element);
          
          this.filteredList.emit(list);
        });
      } else {
        if (this.tagtype === 'project') {
          this.uieventhub.setTagFilterApplied([]);
        }
        this.filteredList.emit(this.listToFilter);
      }
    }
  }

  toggleTags() {
    this.showTags = !this.showTags;
  }

  addTag(tag: Tag) {
    this.uieventhub.addLoader('tagfilter');
    this.tfsrv.addTagToFilter(tag).pipe(untilDestroyed(this)).subscribe(result => {
      if (this.filtertagList.find(x => x.title == tag.title) == undefined) {
        this.filtertagList.push({
          tagId: tag.tagId,
          title: tag.title,
          tagtype: this.tagtype,
          created: new Date().toDateString(),
          creator: SessionHelper.getUserSub(),
          organizationId: tag.organizationId,
          organizationname: tag.organizationname,
          personId: SessionHelper.getUserSub()
        });
        this.filterList();
        this.uieventhub.removeLoader('tagfilter');
      }
    });
  }
  removeTag(filterTag: Filtertag) {
    this.uieventhub.addLoader('tagfilter');
    this.tfsrv.removeTagFromFilter(filterTag).pipe(untilDestroyed(this)).subscribe(result => {
      // Remove from local list immediately for instant feedback
      const index = this.filtertagList.indexOf(filterTag);
      if (index > -1) {
        this.filtertagList = [...this.filtertagList.slice(0, index), ...this.filtertagList.slice(index + 1)];
      }

      // Update datastore to trigger all subscriptions
      this.datastore.filtertagList.next(
        this.datastore.filtertagList.getValue().filter(ft =>
          !(ft.tagId === filterTag.tagId && ft.tagtype === filterTag.tagtype)
        )
      );

      this.filterList();

      // Force update parent components
      if (this.tagtype === 'project') {
        this.uieventhub.setTagFilterApplied(this.filtertagList);
      }

      this.uieventhub.removeLoader('tagfilter');
    });

  }
  createTag(title: string) {

    if (this.filtertagList.find(x => x.title == title) == undefined) {
      let newtag = new Tag;
      newtag = {
        tagId: new Date().toDateString(),
        title: title,
        tagtype: 'customer',
        created: new Date().toDateString(),
        creator: SessionHelper.getUserSub(),
        organizationId: SessionHelper.getChoosenOrg(),
        organizationname: 'tt'
      };
      this.tfsrv.saveTag(newtag).pipe(untilDestroyed(this)).subscribe(newid => {
        newtag.tagId = newid;
        this.taglist.push(newtag);
        let newFiltertag = new Filtertag;
        newFiltertag = {
          tagId: newtag.tagId,
          title: newtag.title,
          tagtype: this.tagtype,
          created: new Date().toDateString(),
          creator: SessionHelper.getUserSub(),
          organizationId: newtag.organizationId,
          organizationname: newtag.organizationname,
          personId: SessionHelper.getUserSub()
        };
        this.tfsrv.addTagToFilter(newtag).pipe(untilDestroyed(this)).subscribe(x => {
          this.filtertagList.push();
        });

      });

    }
  }

}
